// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nsection[data-v-48a385e1]{\n  height: calc( 100% - 60px );\n}\n.note-content[data-v-48a385e1]{\n  height: fit-content;\n  max-height: calc( 100% - 40px );\n  overflow: hidden;\n  overflow-y: auto;\n}\n.button-div[data-v-48a385e1]{\n  height: 40px;\n}\n.card[data-v-48a385e1]{\n  width: 22rem;\n}\n", ""]);
// Exports
module.exports = exports;
